/**
 * Волна C (docs/MIGRATION_ROUTER.md §5). Было: <PrivateRoute path='/cook'>.
 * exact
 */
import { createFileRoute } from '@tanstack/react-router';
import CacheDataRoute from '../../CacheDataRoute';
import ChefBlog from '@routes/ChefBlog';

export const Route = createFileRoute('/cook/')({
  component: () => <CacheDataRoute component={ChefBlog} path='/cook' />
});
